import request from '../http.js'


class QuestionExercise{
    getQuestionContent(data) {
        return request.post('/question/content/get', data)
    }
    getWrongQuestion(data) {
        return request.post('/practice/wrong/get', data)
    }
    savePracticeStatus(data) {
        return request.post('/practice/status/edit', data)
    }
    getFavQuestion(data) {
        return request.post('/practice/favourite/get', data)
    }
    getQuestionList(data) {
        return request.post('/practice/question/get', data)
    }
    getSectionList(data) {
        return request.post('/store/section/get', data)
        
    }
    getStoreList(data) {
        return request.post('/store/list/get', data)
    }
    getRightMessage(data) {
        return request.post('/message/right/get', data)
    }
    clearRecord(data) {
        return request.post('/practice/record/clear', data)
    }
    getAIQuestion(data) {
        return request.post('/practice/ai/get', data)
    }
}



export default new QuestionExercise()